import Vue from "vue";
import Router from "vue-router";
import ElementUI from "element-ui";
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);
import App from "./App";
import router from "./router";
import store from "./store/index";
import "babel-polyfill"; //ie浏览器打不开的问题
import MetaInfo from "vue-meta-info";
import QRCode from "qrcodejs2";
import Viewer from "v-viewer"; //查看大图

import "viewerjs/dist/viewer.css";

//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999
    }
});

// canvas 画海报
import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)



// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// import Axios from 'axios'
// Vue.prototype.$axios=Axios
Vue.use(MetaInfo);
// 按需引入部分组件
Vue.config.productionTip = false;
import HomeTop from "@/components/homeTop/homeTop";
Vue.component(HomeTop.name, HomeTop);

// Vue.prototype.$imgUrl = "https://admin2.2855855.com";
Vue.prototype.$imgUrl = "";
// https://view.officeapps.live.com/op/view.aspx?src= 是微软官网提供的word预览方法
Vue.prototype.$wordUrl = "https://view.officeapps.live.com/op/view.aspx?src=";

import aMap from "vue-amap";

Vue.use(aMap);
// b9783f54fd02810327281500a6f45570
aMap.initAMapApiLoader({
    key: "3e43ab3c7d1355037c7ff1ff45dacf92",
    plugin: ["AMap.Geolocation", "AMap.Geocoder"]
});

// import EventBus from '@/components/homeTop/EventBus.js'
// Vue.prototype.$bus=EventBus
import "element-ui/lib/theme-chalk/index.css";

import { Message } from "element-ui"; //按需加载使用这种方法不对,页面刷新会有空白弹窗

/* Vue.use(Message) */ Vue.component(Message.name, Message); //应该使用这种方式
Vue.prototype.$message = Message;

import api from "./utils/request";
import http from "./utils/http";
import globalFn from "./utils/globalFn.js";
Vue.prototype.$http = http;
Vue.prototype.$api = api;

Vue.prototype.$regexPhone = /^1[0-9]{10,10}$/;
Vue.prototype.$regexID = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
Vue.prototype.$regexNum6 = /^[0-9]{6,6}$/;

Vue.mixin(globalFn);

// if(!window.localStorage){
//   console.log(1)
//   alert("浏览器支持localstorage");
// }else{
//   console.log(2)
//   var storage=window.localStorage;
//   storage["a"]=1;
//   storage.b=6;
//   storage.setItem("c",3);
//   console.log(typeof storage["a"]);
//   console.log(typeof storage["b"]);
//   console.log(typeof storage["c"]);
//   var a=storage.a;
//   console.log(a);
//   var b=storage["b"];
//   console.log(b);
//   var c=storage.getItem("c");
//   console.log(c);
// }

new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>",
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('custom-render-trigger'))
        // document.dispatchEvent(new Event("render-event"));
    }
});

// 防抖处理 -- 最后执行
const on = Vue.prototype.$on
Vue.prototype.$on = function (event, func) {
  let timer
  let newFunc = func
  if (event === 'click') {
    newFunc = function () {
      clearTimeout(timer)
      timer = setTimeout(function () {
        func.apply(this, arguments)
      }, 500)
    }
  }
  on.call(this, event, newFunc)
}
// 节流

/* const on = Vue.prototype.$on;

Vue.prototype.$on = function(event, func) {
    let previous = 0;
    let newFunc = func;
    if (event === "click") {
        newFunc = function() {
            const now = new Date().getTime();
            if (previous + 1000 <= now) {
                func.apply(this, arguments);
                previous = now;
            }
        };
    }
    on.call(this, event, newFunc);
}; */



// WEBPACK FOOTER //
// ./src/main.js